/* Scroll to Top Plus Ultra - fixed bottom-right button (Global section
   group). Reparents itself onto <body> so Shopify section wrappers can't
   clip or contain the fixed position (which was hiding it on desktop). */
if (!customElements.get('scroll-to-top-plus-ultra')) {
  customElements.define(
    'scroll-to-top-plus-ultra',
    class ScrollToTopPlusUltra extends HTMLElement {
      connectedCallback() {
        // Moving the node re-invokes connectedCallback; bail on the first
        // pass so listeners are only wired once on the final parent.
        if (!this.dataset.moved) {
          this.dataset.moved = 'true';
          document.body.appendChild(this);
          return;
        }

        this.showAfter = parseInt(this.dataset.showAfter, 10);
        if (Number.isNaN(this.showAfter)) this.showAfter = 300;

        this.button = this.querySelector('.hdt-stt__button');
        this.onScroll = this.onScroll.bind(this);
        this.onClick = this.onClick.bind(this);

        this.button?.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.button?.removeEventListener('click', this.onClick);
      }

      getScrollY() {
        return window.scrollY || document.documentElement.scrollTop || 0;
      }

      onScroll() {
        this.classList.toggle('is-visible', this.getScrollY() > this.showAfter);
      }

      onClick() {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, left: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    }
  );
}
